import { useEffect } from "react";
import { TermsContent } from "@/components/ec/Terms";
import { DocLink, DocMetaItem, DocumentSection } from "@/components/ec/documentSection";

export function EcTermsPage() {
  useEffect(() => {
    const prev = document.title;
    document.title = "Terms of Service — Autranslate | Monobundle Inc.";
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <DocumentSection
      title="Terms of Service — Autranslate"
      lastUpdated="May 28, 2026"
      appName="Autranslate (オートラ | SEO/GEO対応翻訳AI)"
      extraMeta={
        <DocMetaItem label="Contact / Support:">
          <DocLink href="mailto:yosui262@gmail.com">yosui262@gmail.com</DocLink>
        </DocMetaItem>
      }
    >
      <TermsContent />
    </DocumentSection>
  );
}
